var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "498pt",
    viewBox: "-80 0 498 498.61113",
    width: "498pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "a"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#003f8a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.518,
    stopColor: "#00d7df"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006df0"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    gradientUnits: "userSpaceOnUse",
    x1: -47.012299,
    x2: 427.723701,
    xlinkHref: "#a",
    y1: 504.19513,
    y2: 29.46713
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    gradientUnits: "userSpaceOnUse",
    x1: -74.140299,
    x2: 400.587701,
    xlinkHref: "#a",
    y1: 477.05913,
    y2: 2.33113
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    gradientUnits: "userSpaceOnUse",
    x1: -46.804299,
    x2: 427.923701,
    xlinkHref: "#a",
    y1: 504.40313,
    y2: 29.66713
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    gradientUnits: "userSpaceOnUse",
    x1: -2.140299,
    x2: 472.587701,
    xlinkHref: "#a",
    y1: 549.05913,
    y2: 74.33113
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    gradientUnits: "userSpaceOnUse",
    x1: -126.140299,
    x2: 348.587701,
    xlinkHref: "#a",
    y1: 425.05913,
    y2: -49.66887
  })), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    gradientUnits: "userSpaceOnUse",
    x1: 37.859701,
    x2: 512.587701,
    xlinkHref: "#a",
    y1: 589.05913,
    y2: 114.33113
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    gradientUnits: "userSpaceOnUse",
    x1: 9.859701,
    x2: 484.587701,
    xlinkHref: "#a",
    y1: 561.05913,
    y2: 86.33113
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    gradientUnits: "userSpaceOnUse",
    x1: 57.859701,
    x2: 532.587701,
    xlinkHref: "#a",
    y1: 609.05913,
    y2: 134.33113
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "j",
    gradientUnits: "userSpaceOnUse",
    x1: -156.140299,
    x2: 318.587701,
    xlinkHref: "#a",
    y1: 395.05913,
    y2: -79.66887
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m266.277344 308.027344c3.925781-29.644532 5.941406-59.511719 6.03125-89.417969 0-80.71875-34.402344-152.160156-63.320313-197.878906-9.101562-13.433594-24.464843-21.253907-40.679687-20.7031252-16.21875-.5468748-31.582032 7.2734372-40.679688 20.7109372-28.921875 45.710938-63.320312 117.152344-63.320312 197.871094.097656 30.082031 2.125 60.125 6.0625 89.945313-28.507813 5.894531-52.246094 25.527343-63.382813 52.425781-11.136719 26.898437-8.226562 57.566406 7.777344 81.886719 1.476563 2.234374 3.980469 3.582031 6.660156 3.582031.304688 0 .605469-.015625.90625-.046875 2.988281-.335938 5.535157-2.324219 6.589844-5.144532 9.75-25.402343 32.9375-43.179687 60-46 2.210937 6.648438 4.488281 12.960938 6.859375 18.496094 1.253906 2.9375 4.132812 4.847656 7.328125 4.855469h130.398437c3.179688 0 6.054688-1.882813 7.328126-4.796875 2.398437-5.511719 4.75-11.730469 7.097656-18.808594 27.96875 2.023438 52.238281 20.058594 62.246094 46.253906 1.054687 2.8125 3.597656 4.796876 6.585937 5.136719.296875.03125.601563.046875.902344.046875 2.679687 0 5.183593-1.347656 6.664062-3.582031 9.472657-14.304687 14.5-31.09375 14.457031-48.25-.183593-42.550781-30.652343-78.933594-72.511718-86.582031zm-125.128906-278.746094c6.238281-8.710938 16.449218-13.695312 27.160156-13.253906 10.722656-.457032 20.953125 4.527344 27.199218 13.253906 9.222657 14.621094 17.609376 29.757812 25.113282 45.328125h-104.625c7.515625-15.574219 15.914062-30.707031 25.152344-45.328125zm-119.9375 391.496094c-7.601563-19.546875-6.296876-41.441406 3.566406-59.949219 9.867187-18.511719 27.3125-31.800781 47.777344-36.394531.457031 2.945312.976562 5.808594 1.472656 8.699218.230468 1.382813.457031 2.78125.695312 4.148438 1.066406 5.816406 2.171875 11.496094 3.3125 17.042969.214844 1.023437.457032 2 .679688 3.015625.976562 4.496094 1.996094 8.875 3.058594 13.144531.382812 1.542969.796874 3.046875 1.160156 4.550781.359375 1.503906.75 3.039063 1.148437 4.488282-26.023437 3.78125-49.042969 18.886718-62.871093 41.253906zm206.96875-18.167969h-119.703126c-2.191406-5.542969-4.320312-11.664063-6.351562-18.246094-6.707031-23.015625-11.699219-46.496093-14.9375-70.25l-.046875-.367187v-.160156c-4.460937-31.460938-6.742187-63.195313-6.832031-94.976563.683594-44.148437 10.339844-87.699219 28.382812-128h119.199219c18.054687 40.300781 27.722656 83.847656 28.417969 128-.066406 31.855469-2.367188 63.667969-6.882813 95.203125-1.300781 9.292969-2.855469 18.261719-4.511719 27.023438-.65625 3.480468-1.285156 7.03125-2 10.398437-2.496093 11.847656-5.292968 22.960937-8.328124 33.007813-2.140626 6.945312-4.261719 13-6.40625 18.367187zm89.726562 18.167969c-14.246094-23.085938-38.269531-38.394532-65.214844-41.558594.382813-1.40625.726563-2.910156 1.105469-4.351562.40625-1.601563.796875-3.160157 1.214844-4.800782 1.019531-4.128906 1.996093-8.363281 2.9375-12.703125.253906-1.191406.535156-2.34375.796875-3.550781 1.152344-5.488281 2.234375-11.128906 3.25-16.882812.246094-1.4375.480468-2.910157.71875-4.367188.488281-2.886719.992187-5.75 1.449218-8.6875 21.046876 3.96875 39.238282 17.101562 49.625 35.832031 10.386719 18.730469 11.898438 41.117188 4.117188 61.070313zm0 0",
    fill: "url(#b)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m168.308594 162.609375c-39.765625 0-72 32.238281-72 72 0 39.765625 32.234375 72 72 72 39.761718 0 72-32.234375 72-72-.050782-39.742187-32.257813-71.949219-72-72zm0 128c-30.929688 0-56-25.070313-56-56 0-30.925781 25.070312-56 56-56 30.925781 0 56 25.074219 56 56-.035156 30.914063-25.085938 55.964844-56 56zm0 0",
    fill: "url(#c)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m191.699219 256.449219c-2.933594 3.152343-6.46875 5.679687-10.398438 7.433593-2.652343 1.132813-4.488281 3.609376-4.804687 6.472657-.316406 2.867187.929687 5.679687 3.269531 7.367187 2.335937 1.6875 5.402344 1.988282 8.023437.785156 5.890626-2.613281 11.199219-6.386718 15.597657-11.097656 3.019531-3.226562 2.847656-8.289062-.378907-11.308594-3.226562-3.015624-8.289062-2.847656-11.308593.382813zm0 0",
    fill: "url(#d)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m168.308594 186.609375c-4.417969 0-8 3.582031-8 8 0 4.421875 3.582031 8 8 8 17.671875 0 32 14.328125 32 32 0 4.421875 3.582031 8 8 8 4.417968 0 8-3.578125 8-8-.027344-26.496094-21.503906-47.972656-48-48zm0 0",
    fill: "url(#c)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m208.308594 370.609375h-80c-4.417969 0-8 3.582031-8 8 0 4.421875 3.582031 8 8 8h80c4.417968 0 8-3.578125 8-8 0-4.417969-3.582032-8-8-8zm0 0",
    fill: "url(#e)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m144.308594 138.609375h48c4.417968 0 8-3.578125 8-8 0-4.417969-3.582032-8-8-8h-48c-4.417969 0-8 3.582031-8 8 0 4.421875 3.582031 8 8 8zm0 0",
    fill: "url(#f)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m184.308594 426.609375h-32c-2.320313 0-4.527344 1.007813-6.046875 2.761719s-2.203125 4.078125-1.875 6.375l8 56c.566406 3.941406 3.941406 6.867187 7.921875 6.863281h16c3.980468.003906 7.355468-2.921875 7.917968-6.863281l8-56c.332032-2.296875-.351562-4.621094-1.871093-6.375-1.523438-1.753906-3.726563-2.761719-6.046875-2.761719zm-14.9375 56h-2.128906l-5.710938-40h13.550781zm0 0",
    fill: "url(#g)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m128.308594 426.609375h-32c-2.953125 0-5.664063 1.625-7.054688 4.226563-1.394531 2.601562-1.238281 5.761718.398438 8.214843l32 48c1.957031 2.933594 5.601562 4.242188 8.976562 3.21875 3.371094-1.023437 5.679688-4.132812 5.679688-7.660156v-48c0-4.417969-3.582032-8-8-8zm-8 29.601563-9.050782-13.601563h9.050782zm0 0",
    fill: "url(#h)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m240.308594 426.609375h-32c-4.417969 0-8 3.582031-8 8v48c0 3.527344 2.304687 6.636719 5.679687 7.660156 3.375 1.023438 7.019531-.285156 8.976563-3.21875l32-48c1.636718-2.453125 1.789062-5.613281.398437-8.214843-1.394531-2.601563-4.105469-4.226563-7.054687-4.226563zm-24 29.601563v-13.601563h9.046875zm0 0",
    fill: "url(#i)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m168.308594 66.609375h24c4.417968 0 8-3.578125 8-8 0-4.417969-3.582032-8-8-8h-24c-4.417969 0-8 3.582031-8 8 0 4.421875 3.582031 8 8 8zm0 0",
    fill: "url(#j)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocket);
export default __webpack_public_path__ + "static/media/rocket.98f89bbbeeabd558e7105158da0f985a.svg";
export { ForwardRef as ReactComponent };